var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item-avatar',{class:{ light: _vm.light },attrs:{"color":"primary","size":_vm.size}},[_vm._v(" "+_vm._s(_vm.initials)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }